import { types } from 'mobx-state-tree'

const MovingViolation = types
  .model('MovingViolation', {
    objectId: types.identifier,
    winItName: types.string,
    points: types.maybeNull(types.number),
    additionalNames: types.array(types.string),
    meta: types.array(types.frozen({})),
    displayName: types.string,
    isSuggested: types.optional(types.boolean, false),
    fineAmount: types.maybeNull(types.number),
    insuranceIncreaseEstimate3Years: types.maybeNull(types.number),
    slider: types.frozen({}) // New Jersey & Pennsylvania still need this for speeding violations
  })

export default MovingViolation
